/* room-preview.js — DOM/Overlay-Logik: kuratierte Raeume + eigene Wand.
   Beide Modi rendern auf denselben Canvas -> Verschieben/Skalieren, Eck-Griff und
   griff-freier Export gelten einheitlich. */
(function () {
  'use strict';
  var Core = window.RoomPreviewCore;
  if (!Core) return;

  var overlay = document.querySelector('[data-room-preview-overlay]');
  var openBtn = document.querySelector('[data-room-preview-open]');
  if (!overlay || !openBtn) return;

  // Portal: Overlay ans <body> haengen, damit es nicht im Stacking-Context der
  // sticky Produktspalte (.gitem) gefangen bleibt und dahinter gerendert wird.
  if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

  var stage = overlay.querySelector('[data-room-stage]');
  var canvas = overlay.querySelector('[data-room-canvas]');
  var hint = overlay.querySelector('[data-room-hint]');
  var thumbs = overlay.querySelector('[data-room-thumbs]');
  var closeBtn = overlay.querySelector('[data-room-preview-close]');
  var tabsEl = overlay.querySelector('.room-preview__tabs');
  var ownRow = overlay.querySelector('[data-room-own]');
  var fileInput = overlay.querySelector('[data-room-file]');
  var wallInput = overlay.querySelector('[data-room-wall]');
  var saveBtn = overlay.querySelector('[data-room-save]');
  var truescaleBtn = overlay.querySelector('[data-room-truescale]');
  var ctx = canvas ? canvas.getContext('2d') : null;

  var artSrc = overlay.getAttribute('data-art-src');
  var title = overlay.getAttribute('data-title') || '';
  var dims = Core.parseBxh(overlay.getAttribute('data-bxh'));

  var roomsEl = document.querySelector('[data-room-preview-rooms]');
  var rooms = [];
  try { rooms = JSON.parse(roomsEl.textContent); } catch (e) { rooms = []; }
  var activeRoom = rooms[0] || null;

  var artImg = new Image(); artImg.crossOrigin = 'anonymous'; artImg.src = artSrc;
  var roomImg = new Image(); roomImg.crossOrigin = 'anonymous';
  var photoImg = null;                 // eigenes Wandfoto (oder null)
  var bgImg = null;                    // aktiver Hintergrund (Raumbild ODER eigenes Foto)

  // Getrennte Werk-Rechtecke je Modus, damit Positionen sich nicht gegenseitig ueberschreiben.
  var artRooms = { x: 40, y: 40, w: 200, h: 200 };
  var artOwn = { x: 40, y: 40, w: 200, h: 200 };
  var art = artRooms;

  var mode = 'rooms';
  var dpr = 1;
  var MAX_EDGE = 1600;

  // ---------- Canvas / Zeichnen ----------
  function sizeCanvasToStage() {
    var rect = stage.getBoundingClientRect();
    dpr = Math.min(window.devicePixelRatio || 1, 2);  // scharfer Preview/Export auf Retina
    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);
  }
  function drawHandle() {
    var s = Math.round(16 * dpr);
    var hx = art.x + art.w, hy = art.y + art.h;
    ctx.save();
    ctx.fillStyle = '#ffffff'; ctx.strokeStyle = '#111111';
    ctx.lineWidth = Math.max(1, Math.round(dpr));
    ctx.beginPath(); ctx.rect(hx - s / 2, hy - s / 2, s, s); ctx.fill(); ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(hx - s / 2 + 3 * dpr, hy + s / 2 - 3 * dpr);
    ctx.lineTo(hx + s / 2 - 3 * dpr, hy - s / 2 + 3 * dpr);
    ctx.stroke();
    ctx.restore();
  }
  // hideHandle=true -> ohne Griff (fuer Export)
  function draw(hideHandle) {
    if (!ctx) return;
    sizeCanvasToStage();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (bgImg) { ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height); }
    else { ctx.fillStyle = '#eee'; ctx.fillRect(0, 0, canvas.width, canvas.height); }
    if (artImg.complete && artImg.naturalWidth) {
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,.35)'; ctx.shadowBlur = 18; ctx.shadowOffsetY = 6;
      ctx.drawImage(artImg, art.x, art.y, art.w, art.h);
      ctx.restore();
      if (bgImg && !hideHandle) drawHandle();
    }
  }

  // ---------- Werk-Rechteck initialisieren ----------
  function artRatio() {
    if (dims) return dims.heightCm / dims.widthCm;
    return (artImg.naturalWidth && artImg.naturalHeight) ? (artImg.naturalHeight / artImg.naturalWidth) : 1.2;
  }
  function roomPxPerCm() {
    return activeRoom ? (activeRoom.pxPerCm * (canvas.width / activeRoom.naturalWidth)) : 0;
  }
  function initArtRoom() {
    if (dims && activeRoom) {
      var ppc = roomPxPerCm();
      artRooms.w = Math.round(dims.widthCm * ppc);
      artRooms.h = Math.round(dims.heightCm * ppc);
    } else {
      artRooms.w = Math.round(canvas.width * 0.35);
      artRooms.h = Math.round(artRooms.w * artRatio());
    }
    var cx = canvas.width * ((activeRoom ? activeRoom.centerXPct : 50) / 100);
    var cy = canvas.height * ((activeRoom ? activeRoom.centerYPct : 40) / 100);
    artRooms.x = Math.round(cx - artRooms.w / 2);
    artRooms.y = Math.round(cy - artRooms.h / 2);
  }
  function initArtOwn() {
    artOwn.w = Math.round(canvas.width * 0.4);
    artOwn.h = Math.round(artOwn.w * artRatio());
    artOwn.x = Math.round((canvas.width - artOwn.w) / 2);
    artOwn.y = Math.round((canvas.height - artOwn.h) / 2);
  }

  // ---------- Beispielraeume ----------
  function selectRoom(room) {
    activeRoom = room;
    Array.prototype.forEach.call(thumbs.children, function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-room-id') === room.id);
    });
    function ready() {
      if (mode !== 'rooms') return;
      bgImg = roomImg; sizeCanvasToStage(); initArtRoom(); draw();
      if (saveBtn) saveBtn.hidden = false;
      updateHint();
    }
    roomImg.onload = ready;
    roomImg.src = room.src;
    if (roomImg.complete && roomImg.naturalWidth) ready();
  }
  function buildThumbs() {
    thumbs.innerHTML = '';
    rooms.forEach(function (room) {
      var t = document.createElement('img');
      t.className = 'room-preview__thumb';
      t.src = room.src; t.alt = room.label; t.setAttribute('data-room-id', room.id);
      t.addEventListener('click', function () { selectRoom(room); });
      thumbs.appendChild(t);
    });
  }

  // ---------- Hinweise ----------
  function updateRoomsHint() {
    if (dims && activeRoom) {
      var ppc = roomPxPerCm();
      var cm = ppc ? Math.round(art.w / ppc) : dims.widthCm;
      hint.textContent = 'Werk: ' + dims.widthCm + ' × ' + dims.heightCm +
        ' cm. Aktuell im Raum ~' + cm + ' cm breit. Ziehen zum Verschieben, Ecke zum Skalieren.';
    } else {
      hint.textContent = 'Vorschau ohne Maßstab. Ziehen zum Verschieben, Ecke zum Skalieren.';
    }
  }
  function updateOwnHint() {
    var base = dims ? ('Werk: ' + dims.widthCm + ' × ' + dims.heightCm + ' cm. ') : '';
    var wall = parseFloat(wallInput && wallInput.value);
    if (wall > 0 && photoImg) {
      var cm = Core.computeWallCm(art.w, canvas.width, wall);
      hint.textContent = base + 'An deiner Wand aktuell ~' + cm + ' cm breit.';
    } else {
      hint.textContent = base + 'Ziehen zum Verschieben, Ecke zum Skalieren. Wandbreite eingeben für cm-Anzeige.';
    }
  }
  function updateHint() { if (mode === 'rooms') updateRoomsHint(); else updateOwnHint(); }

  // ---------- Tabs ----------
  function setTab(name) {
    mode = name;
    Array.prototype.forEach.call(tabsEl.querySelectorAll('.room-preview__tab'), function (btn) {
      var on = btn.getAttribute('data-room-tab') === name;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var roomsMode = (name === 'rooms');
    art = roomsMode ? artRooms : artOwn;
    thumbs.hidden = !roomsMode;
    if (ownRow) ownRow.hidden = roomsMode;
    if (truescaleBtn) truescaleBtn.hidden = roomsMode || !dims;
    if (roomsMode) {
      if (activeRoom) selectRoom(activeRoom);
    } else {
      bgImg = photoImg;
      if (photoImg) sizeCanvasToStage();
      draw();
      updateHint();
    }
    if (saveBtn) saveBtn.hidden = !bgImg;
  }
  if (tabsEl) {
    tabsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.room-preview__tab');
      if (btn) setTab(btn.getAttribute('data-room-tab'));
    });
  }

  // ---------- Eigenes Foto (nur lokal, kein Upload) ----------
  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          function apply(im) {
            photoImg = im; bgImg = im; sizeCanvasToStage(); initArtOwn(); draw();
            if (saveBtn) saveBtn.hidden = false; updateOwnHint();
          }
          var scale = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
          if (scale < 1) {
            var off = document.createElement('canvas');
            off.width = Math.round(img.width * scale);
            off.height = Math.round(img.height * scale);
            off.getContext('2d').drawImage(img, 0, 0, off.width, off.height);
            var scaled = new Image();
            scaled.onload = function () { apply(scaled); };
            scaled.src = off.toDataURL('image/jpeg', 0.9);
          } else { apply(img); }
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);  // rein lokal
    });
  }
  if (wallInput) wallInput.addEventListener('input', updateOwnHint);

  // ---------- Verschieben / Skalieren (beide Modi) ----------
  var drag = null;
  function pointerPos(e) {
    var r = canvas.getBoundingClientRect();
    var p = (e.touches && e.touches[0]) || e;
    return { x: (p.clientX - r.left) * (canvas.width / r.width),
             y: (p.clientY - r.top) * (canvas.height / r.height) };
  }
  function onHandle(pos) {
    var t = 22 * dpr;
    return Math.abs(pos.x - (art.x + art.w)) < t && Math.abs(pos.y - (art.y + art.h)) < t;
  }
  function inArt(pos) {
    return pos.x >= art.x && pos.x <= art.x + art.w && pos.y >= art.y && pos.y <= art.y + art.h;
  }
  function startDrag(e) {
    if (!bgImg) return;
    var pos = pointerPos(e);
    if (onHandle(pos)) drag = { mode: 'scale', startX: pos.x, orig: { w: art.w, h: art.h, ratio: art.h / art.w } };
    else if (inArt(pos)) drag = { mode: 'move', startX: pos.x, startY: pos.y, orig: { x: art.x, y: art.y } };
    if (drag) e.preventDefault();
  }
  function moveDrag(e) {
    if (!drag) return;
    var pos = pointerPos(e);
    if (drag.mode === 'move') {
      art.x = drag.orig.x + (pos.x - drag.startX);
      art.y = drag.orig.y + (pos.y - drag.startY);
    } else {
      var newW = Math.max(30, drag.orig.w + (pos.x - drag.startX));
      art.w = Math.round(newW); art.h = Math.round(newW * drag.orig.ratio);
    }
    draw(); updateHint(); e.preventDefault();
  }
  function endDrag() { drag = null; }
  function updateCursor(e) {
    if (!bgImg) { canvas.style.cursor = ''; return; }
    var pos = pointerPos(e);
    canvas.style.cursor = onHandle(pos) ? 'nwse-resize' : (inArt(pos) ? 'move' : 'default');
  }
  if (canvas) {
    canvas.addEventListener('mousedown', startDrag);
    window.addEventListener('mousemove', moveDrag);
    window.addEventListener('mouseup', endDrag);
    canvas.addEventListener('mousemove', updateCursor);
    canvas.addEventListener('touchstart', startDrag, { passive: false });
    canvas.addEventListener('touchmove', moveDrag, { passive: false });
    canvas.addEventListener('touchend', endDrag);
  }

  // ---------- In Originalgröße (nur eigenes Foto + Maße + Wandbreite) ----------
  if (truescaleBtn) {
    truescaleBtn.addEventListener('click', function () {
      if (!photoImg) { hint.textContent = 'Bitte zuerst ein Wandfoto wählen.'; return; }
      if (!dims) return;
      var wall = parseFloat(wallInput && wallInput.value);
      if (!(wall > 0)) {
        hint.textContent = 'Werk: ' + dims.widthCm + ' × ' + dims.heightCm +
          ' cm. Bitte zuerst die Wandbreite (cm) eingeben, dann Originalgröße zeigen.';
        if (wallInput) wallInput.focus();
        return;
      }
      sizeCanvasToStage();
      var ppc = canvas.width / wall;             // ganze Fotobreite = wall cm
      artOwn.w = Math.round(dims.widthCm * ppc);
      artOwn.h = Math.round(dims.heightCm * ppc);
      artOwn.x = Math.round((canvas.width - artOwn.w) / 2);
      artOwn.y = Math.round((canvas.height - artOwn.h) / 2);
      draw(); updateOwnHint();
    });
  }

  // ---------- Speichern (ohne Griff im Bild) ----------
  if (saveBtn) {
    saveBtn.addEventListener('click', function () {
      if (!bgImg) return;
      draw(true);                                // Griff fuer Export ausblenden
      try {
        var url = canvas.toDataURL('image/png');
        var a = document.createElement('a');
        a.href = url; a.download = (title || 'werk') + '-im-raum.png';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
      } catch (err) { /* toDataURL scheitert nur bei fremd-origin; hier same-origin CDN mit CORS */ }
      draw();                                    // Griff wieder anzeigen
    });
  }

  // ---------- Overlay-Lifecycle + a11y ----------
  var lastFocus = null;
  function openOverlay() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    if (canvas) canvas.hidden = false;
    if (!thumbs.children.length) buildThumbs();
    setTab(mode);                                // aktuellen Modus einrichten + zeichnen
    if (closeBtn) closeBtn.focus();
  }
  function closeOverlay() {
    overlay.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }
  function trapFocus(e) {
    if (e.key !== 'Tab' || overlay.hidden) return;
    var nodes = overlay.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
    var f = Array.prototype.filter.call(nodes, function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }
  overlay.addEventListener('keydown', trapFocus);

  openBtn.addEventListener('click', openOverlay);
  closeBtn.addEventListener('click', closeOverlay);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) closeOverlay(); });
  artImg.addEventListener('load', function () { if (!overlay.hidden) { draw(); updateHint(); } });
  window.addEventListener('resize', function () {
    if (overlay.hidden) return;
    if (mode === 'rooms' && activeRoom) { sizeCanvasToStage(); initArtRoom(); }
    draw(); updateHint();
  });
})();
